import Cookies from 'universal-cookie';
import { create } from 'zustand';

const cookies = new Cookies();

interface AuthState {
	orgJWT: string | null;
	schedJWT: string | null;
	ssId: string | null;
	accountId: string | null;
	setOrgJWT: (token: string) => void;
	setSession: (sessionData: { schedJWT: string; ssId: string }) => void;
	setAccountId: (id: string) => void;
	clearAuth: () => void;
	clearSession: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
	orgJWT: cookies.get('orgJWT') || null,
	schedJWT: cookies.get('schedJWT') || null,
	ssId: cookies.get('ssId') || null,
	accountId: cookies.get('accountId') || null,

	setOrgJWT: (token: string) => {
		set({ orgJWT: token });
	},

	setSession: ({ schedJWT, ssId }) => {
		set({ schedJWT, ssId });
	},

	setAccountId: (id: string) => {
		set({ accountId: id });
	},

	clearAuth: () => {
		cookies.remove('orgJWT', { path: '/' });
		cookies.remove('schedJWT', { path: '/' });
		cookies.remove('ssId', { path: '/' });
		cookies.remove('accountId', { path: '/' });
		set({ orgJWT: null, schedJWT: null, ssId: null, accountId: null });
	},

	clearSession: () => {
		cookies.remove('schedJWT', { path: '/' });
		cookies.remove('ssId', { path: '/' });
		set({ schedJWT: null, ssId: null });
	},
}));
